import { createSelector } from 'reselect';
import { selectUser, selectInstitution } from '../../../store/features/system';
import { shouldHideExtensionSettinsForNotClinic, isExtensionInstalled, } from '../../core/helpers/extension';
import { nativeExtensionsListWithSettings } from '../../core/constants/extension';
import { MODULE_NAME } from '../constants';
export const selectExtensionsList = (state) => state[MODULE_NAME].extensionsList;
export const selectinstalledNativeExtensionsWithSettings = createSelector(selectUser, selectInstitution, selectExtensionsList, (user, institution, extensions) => {
    return extensions.filter((extention) => {
        return (isExtensionInstalled(extention, user, institution) &&
            nativeExtensionsListWithSettings.includes(extention.name) &&
            !shouldHideExtensionSettinsForNotClinic(extention, institution));
    });
});
export const selectHasNewExtensions = (state) => state[MODULE_NAME].hasNewExtensions;
